module.exports = __webpack_public_path__ + "img/c5201809-3.3a7f97bf.jpg";